module.exports = __webpack_public_path__ + "img/acmedUploadInfoTable.0bb20f61.png";